module.exports = __webpack_public_path__ + "img/logo-mob.png";